/**
 * Technical guard only — the app does not enforce Secret Hitler's real 5-10
 * player range. Set at 15 rather than higher because the projector has to show
 * every ballot card legibly across a lit room: hedging for a headcount the game
 * never reaches would shrink the cards for the headcounts it actually has.
 */
export const MAX_PLAYERS = 15;

/** The board's election tracker: 0..3. Reaching 3 is chaos. */
export const MAX_FAILED_ELECTIONS = 3;

/**
 * With this many players alive or fewer, only the last elected *chancellor* is
 * term-limited (the last elected president becomes eligible again).
 */
export const SMALL_TABLE_ALIVE_THRESHOLD = 5;

/** A room with no voting session started for this long is closed automatically. */
export const ROOM_TTL_MS = 12 * 60 * 60 * 1000;

export const MAX_NAME_LENGTH = 24;
export const MIN_NAME_LENGTH = 1;

/** Avatars are downscaled client-side before upload; this is the post-encode ceiling. */
export const AVATAR_MAX_BYTES = 100 * 1024;
export const AVATAR_DIMENSION = 256;
export const AVATAR_MIME = 'image/webp';

/**
 * One colour per player, assigned uniquely on join. Unique names plus unique
 * colours make every initials-placeholder distinguishable by construction, so
 * no initials-collision tie-breaking is needed.
 *
 * Deliberately exactly MAX_PLAYERS long and spread right around the hue wheel:
 * a longer palette can only be built by adding near-duplicates, and two players
 * with similar colours is the one failure this mechanism exists to prevent.
 * All are dark enough to carry white initials.
 *
 * The *order* matters as much as the set. Colours are handed out by lowest free
 * index, so the sequence alternates around the wheel rather than walking it:
 * that way the five or six players an actual game has are maximally separated,
 * instead of all landing in the warm quadrant.
 */
export const PLAYER_COLORS = [
  '#c0392b', // red
  '#0f766e', // teal
  '#c2570c', // orange
  '#1d4ed8', // blue
  '#5c6e10', // olive
  '#a8258f', // magenta
  '#1f6f8c', // steel
  '#8f6d12', // mustard
  '#3b2fa8', // indigo
  '#2d7d46', // green
  '#b81b62', // pink
  '#7b2fb5', // violet
  '#6b4420', // brown
  '#46525c', // slate
  '#8b1a1a', // maroon
] as const;
